module.exports = __webpack_public_path__ + "img/2-3.54c8a490.jpg";